import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import Container from './style'

interface Props {
  children: ReactNode[]
  style?: CSSProperties
  className?: string
  id?: string
}

function List({ id, className, style, children }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      {children}
    </Container>
  )
}

List.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

List.defaultProps = {
  className: '',
}

export default memo(List)
